// Latham's standard slack for a cover, in inches: the extra fabric that lets it sit down on the water.
// Shared by the Latham order's Slack field and the Auto Cover tracker, which shows the slack the
// replacement quote will open with, so the two can't disagree.
//
// Null until the track space is known. A track that is neither under nor top track (isUndertrack
// undefined) gets 0, which is what the order has always done.
export function calculateLathamSlack(brandType: string, isUndertrack: boolean, trackSpaceFeet: number): number {
	if (!trackSpaceFeet)
		return null;

	let slack = 0;

	if (brandType === 'Coverstar') {
		if (isUndertrack === true) {
			if (trackSpaceFeet <= 10)
				slack = 4;
			else if (trackSpaceFeet <= 16)
				slack = 5;
			else
				slack = 6;
		}
		else if (isUndertrack === false) {
			if (trackSpaceFeet <= 10)
				slack = 5;
			else if (trackSpaceFeet <= 16)
				slack = 6;
			else
				slack = 7;
		}
	}
	else if (brandType === 'PCS') {
		if (isUndertrack === true)
			slack = 5;
		else if (isUndertrack === false)
			slack = 7;
	}

	return slack;
}
